import React from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

interface ReferralExpirationTextProps {
    expirationTimestamp: number;
}

export const ReferralExpirationText: React.FC<ReferralExpirationTextProps> = ({ expirationTimestamp }) => {
    const getDaysDifference = () => {
        if (!expirationTimestamp) return null;

        const expireDate = new Date(expirationTimestamp * 1000);
        const currentDate = new Date();

        // Reset time to midnight for accurate day calculation
        expireDate.setHours(0, 0, 0, 0);
        currentDate.setHours(0, 0, 0, 0);

        // Calculate difference in milliseconds and convert to days
        const diffTime = expireDate.getTime() - currentDate.getTime();
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        return diffDays;
    };

    const daysDiff = getDaysDifference();
    if (daysDiff === null) return null;

    const daysText = Math.abs(daysDiff) === 1 ? "day" : "days";
    let message = "";

    if (daysDiff < 0) {
        message = `Expired ${Math.abs(daysDiff)} ${daysText} ago`;
    } else if (daysDiff === 0) {
        message = "Expires today";
    } else {
        message = `Expires in ${daysDiff} ${daysText}`;
    }

    return (
        <Text variant="V2.overline.neutral.medium" color="warning">
            {message}
        </Text>
    );
};
